import {
  Box,
  Button,
  Dialog,
  DialogContentText,
  Typography,
  CircularProgress
} from '@mui/material';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LazyImage from '../../../../../components/LazyImage/LazyImage';
import CloseIcon from '@mui/icons-material/Close';
import AppFile from '../../../../../models/AppFile';
import { FileType } from '../../../../../models/FileType';
import FileUploadButton from '../../FileUpload/FileUpload';
interface RequestFileRowProps {
  documentId: string;
  url: string | undefined;
  title: string | undefined;
  documentName: string;
  isLast?: boolean;
  canUpdate?: boolean;
  documentType: FileType | undefined;
  maxSize: string;
  removeFile: (documentId: string) => void;
  addFile: (appFile: AppFile) => void;
  documents: AppFile;
}

const RequestFileRow: React.FC<RequestFileRowProps> = ({
  documentId,
  url,
  title,
  documentName,
  isLast = false,
  canUpdate = false,
  documentType,
  maxSize,
  removeFile,
  addFile,
  documents
}) => {
  const { t } = useTranslation();
  const [showDocument, setShowDocument] = useState(false);
  const handleClose = () => {
    setShowDocument(false);
  };

  const handlerOnFileUploaded = (appFile: AppFile | null) => {
    if (appFile === null) {
      removeFile(documentId);
    } else {
      addFile({ ...appFile, file_name: documentName, id: documentId });
    }
  };

  const getLabel = () => {
    if (documentType === 'DU_FRONT' || documentType === 'DU_BACK') {
      return t('selectImage');
    }
    return t('selectPdf');
  };
  return (
    <>
      {canUpdate && (
        <FileUploadButton
          defaultFile={null}
          documentAllowedSize={maxSize}
          documentType={documentType!}
          inputFileDocumentName={documentName}
          label={getLabel()}
          onFileUploded={handlerOnFileUploaded}
          key={documentId}
          documents={documents}
        />
      )}
      {showDocument && url !== undefined && (
        <Dialog open={showDocument} onClose={handleClose}>
          <Box className='ConfirmDialog-TitleBox'>
            <Typography variant='h6' className='ConfirmDialog-Title'>
              {documentName}
            </Typography>
            <Button className='ConfirmDialog-Close' onClick={handleClose}>
              <CloseIcon fontSize='small' />
            </Button>
          </Box>
          <DialogContentText>
            <Suspense
              fallback={
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                    padding: '15px'
                  }}
                >
                  <CircularProgress />
                </Box>
              }
            >
              <LazyImage src={url} width='100%' />
            </Suspense>
          </DialogContentText>
        </Dialog>
      )}
    </>
  );
};
export default RequestFileRow;
